import React from 'react'
import { Avatar, Dropdown, type MenuProps } from 'antd'
import {
  BellOutlined,
  GlobalOutlined,
  HistoryOutlined,
  LockOutlined,
  LogoutOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../../hooks/hooks'
import { setLanguage } from '../../../store/slices/LanguageSlice'
import { logoutUser } from '../../../store/slices/SessionSlice'
import { redirectToKeycloakLogin } from '../../../utils/keycloak'
import { useTranslation } from '../../../hooks/useTranslation'
import { userMenuItems } from '../../../../mock/dataMock'

const iconMap: Record<string, React.ReactNode> = {
  UserOutlined: <UserOutlined />,
  SettingOutlined: <SettingOutlined />,
  LockOutlined: <LockOutlined />,
  BellOutlined: <BellOutlined />,
  HistoryOutlined: <HistoryOutlined />,
  QuestionCircleOutlined: <QuestionCircleOutlined />,
  LogoutOutlined: <LogoutOutlined />,
}

interface UserMenuProps {
  initials?: string
}

const UserMenu: React.FC<UserMenuProps> = ({ initials = 'JD' }) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleRoute = async (route: string) => {
    if (route === '/logout') {
      await dispatch(logoutUser())
      redirectToKeycloakLogin()
      return
    }
    navigate(route)
  }

  const languageMenu: NonNullable<MenuProps['items']> = [
    { key: 'lang-en', label: 'English', onClick: () => dispatch(setLanguage('en')) },
    { key: 'lang-es', label: 'Español', onClick: () => dispatch(setLanguage('es')) },
  ]

  const items: MenuProps['items'] = [
    ...userMenuItems.map((item) => {
      if (item.type === 'divider') {
        return { key: item.key, type: 'divider' as const }
      }
      return {
        key: item.key,
        icon: item.icon ? iconMap[item.icon] : undefined,
        label: t(`navigation.userMenu.${item.translationKey}`),
        danger: item.danger || false,
        onClick: () => handleRoute(item.route!),
      }
    }),
    { key: 'lang-divider', type: 'divider' as const },
    {
      key: 'language',
      icon: <GlobalOutlined />,
      label: t('navigation.userMenu.language'),
      children: languageMenu,
    },
  ]

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
      <Avatar shape="circle" size={32} className="gt-header-avatar">
        {initials}
      </Avatar>
    </Dropdown>
  )
}

export default UserMenu
